export enum DeliveryTabs {
  MAP = 'map',
  NO_SERVICE_OFFERS = 'no-service-offers'
}

export enum ProductsCatalogTab {
  PRODUCTS = 'products',
  TEMPLATE_LIBRARY = 'template-library'
}

export enum BookingDetailTab {
  DETAILS = 'details',
  SMS = 'sms',
  ORDER = 'order',
  ROUTE = 'route',
  EVENTS = 'events',
  INSPECTION = 'inspection',
  LEAD_GENERATION = 'lead-generation',
  NOTIFICATIONS = 'notifications',
  TASKS = 'tasks',
  TICKETS = 'tickets',
  MAP = 'map'
}

export enum CarTab {
  OVERVIEW = 'overview',
  BOOKINGS = 'bookings',
  GENERAL = 'general',
  TICKETS = 'tickets',
  WHEEL_HISTORY = 'wheel-history',
  TIRE_OFFERS = 'tire-offers'
}

export enum WheelSetTab {
  OVERVIEW = 'overview',
  WHEEL_HISTORY = 'wheel-history',
  TIRE_OFFERS = 'tire-offers'
}

export const CAR_USER_GROUP_QUERY_PARAM = 'user-group-id';

export enum TireOfferTab {
  DETAILS = 'details',
  STATUS_EVENTS = 'status-events',
  INTERACTIONS = 'interactions',
  NOTES = 'notes',
  VIEWS = 'views',
  INVENTORY_ORDER = 'inventory-order',
  TICKETS = 'tickets'
}

export enum WorkerContractTab {
  DETAILS = 'details',
  ADDRESSES = 'addresses'
}

export enum StorageFacilityTab {
  DETAILS = 'details',
  STORAGE = 'storage',
  TRANSFER_ORDERS = 'transfer-orders',
  OPENING_HOURS = 'opening-hours',
  WHEEL_SET_COUNTS = 'wheel-set-counts'
}

export enum TireHotelLocationTab {
  DETAILS = 'details',
  OPENING_HOURS = 'opening-hours',
  NOTES = 'notes'
}

export enum WebhookTab {
  DETAILS = 'details',
  LOG = 'log'
}

/** Query param `scope` on partner webhook routes: org-level vs current service department. */
export enum WebhookEndpointScope {
  ORGANIZATION = 'organization',
  DEPARTMENT = 'department'
}

export enum AdvancedSettingsTab {
  WEBHOOKS = 'webhooks'
}

export enum RouteStatusTab {
  GENERAL_INFO = 'general-info',
  MAP = 'map'
}

/** Route status: which route's details sheet is open. */
export const ROUTE_DETAILS_QUERY_PARAM = 'route-details';

/** Route status: the open/closed state of one status group, so a deep link can mount the row it points at. */
export const ROUTE_STATUS_GROUP_QUERY_PARAMS = {
  inProgress: 'group-in-progress',
  notStarted: 'group-not-started',
  completed: 'group-completed'
} as const;

/** How much of the garage schedule is on screen: a week of lanes, or a month of days. */
export enum ScheduleView {
  WEEK = 'week',
  MONTH = 'month'
}

/**
 * Which channel lane a screen that serves both is showing — the calendar and Today share it, so a
 * department that runs both keeps the same choice as it moves between them. Mobile leads.
 */
export enum ChannelView {
  SERVICE_CENTER = 'service-center',
  MOBILE = 'mobile'
}

export enum RoutePlanningTab {
  PLAN = 'plan',
  SETTINGS = 'settings',
  BOOKING_UPDATE_REQUESTS = 'booking-update-requests'
}

export enum CustomerDetailTab {
  OVERVIEW = 'overview',
  BOOKINGS = 'bookings',
  CARS = 'cars',
  FEEDBACKS = 'feedbacks',
  PRICING_AGREEMENTS = 'pricing-agreements',
  COMMUNICATION = 'communication',
  MEMBERS = 'members',
  NOTES = 'notes',
  TIRE_OFFERS = 'tire-offers',
  TIRE_HOTEL = 'tire-hotel',
  NOTIFICATIONS = 'notifications',
  IAM = 'iam',
  ADDRESSES = 'addresses',
  RECALLS = 'recalls',
  INVOICES = 'invoices',
  COUPONS = 'coupons',
  REFERRALS = 'referrals',
  EVENTS = 'events',
  LOGINS = 'logins'
}

export enum WorkerShiftTab {
  DETAILS = 'details',
  AREA = 'area',
  ACTIVITY = 'activity'
}

export enum WmsWarehouseTab {
  STOCK = 'stock',
  DETAILS = 'details',
  ISSUES = 'issues',
  POSITIONS = 'positions',
  RESERVATIONS = 'reservations',
  ALLOCATIONS = 'allocations',
  MOVEMENTS = 'movements'
}

export enum TireInventoryConfigurationTab {
  TIRE_BRAND_AND_MODELS = 'tire-brand-and-models',
  TIRE_SUPPLIERS = 'tire-suppliers'
}

export enum SalesItemTab {
  DETAILS = 'details',
  OFFERS = 'offers',
  AVAILABILITY_RULES = 'availability-rules',
  BOOKING_FLOW_UI = 'booking-flow-ui',
  TASKS = 'tasks'
}

export enum WorkerDetailTab {
  DETAILS = 'details',
  CALENDAR = 'calendar',
  CONTRACTS = 'contracts',
  VEHICLES = 'vehicles',
  BOOKINGS = 'bookings',
  ABSENCES = 'absences',
  SHIFTS = 'shifts',
  TIME_LOGS = 'time-logs',
  TIMELINE = 'timeline',
  WORKED_HOURS = 'worked-hours',
  WORK_SETTLEMENTS = 'work-settlements',
  FEEDBACKS = 'feedbacks',
  COMMUNICATION = 'communication',
  INSPECTIONS = 'inspections'
}

export enum WorkerTimeTrackingTab {
  ACTIVITY = 'activity',
  TIMELINE = 'timeline',
  OVERTIME = 'overtime',
  TEAM_STATUS = 'team-status',
  TIME_LOGS = 'time-logs',
  WORKED_HOURS = 'worked-hours'
}

export enum WorkerTimeTrackingSettingsTab {
  OVERTIME = 'overtime',
  CLOCK_OUT_AND_REST = 'clock-out-and-rest',
  HOURLY_BONUS = 'hourly-bonus',
  BONUS_WORKERS = 'bonus-workers',
  BONUS_SERVICES = 'bonus-services'
}

export enum WorkerTimeLogDetailTab {
  OVERVIEW = 'overview',
  TIMELINE = 'timeline',
  LOCATIONS = 'locations'
}

export enum TaskTab {
  REUSABLE_TASKS = 'reusable-tasks',
  TASKS = 'tasks'
}

export enum TaskDetailTab {
  DETAILS = 'details',
  CHANGELOG = 'changelog'
}

export enum TaskTemplateDetailTab {
  DETAILS = 'details',
  CHANGELOG = 'changelog'
}

export enum RecallListViewTab {
  LIST = 'list',
  MAP = 'map'
}

/** Status tabs on the unified partner Recalls work page (`/recalls?status=`). */
export enum RecallsStatusTab {
  DRAFT = 'draft',
  NOT_NOTIFIED = 'not-notified',
  PENDING = 'pending',
  PUBLISHED = 'published',
  AUTO_BOOKING = 'auto-booking',
  AUTO_BOOKING_NOT_NOTIFIED = 'auto-booking-not-notified',
  ALL = 'all',
  HISTORY = 'history'
}

export enum RecallDetailTab {
  DETAILS = 'details',
  MAP = 'map',
  BOOKING_HISTORY = 'booking-history'
}

export enum SkipReasonTab {
  SKIP_REASONS = 'skip-reasons',
  TAGS = 'tags'
}

export enum SupplierOrdersTab {
  ORDERS = 'orders',
  EXCEPTIONS = 'exceptions'
}

export enum FleetScheduleDetailTab {
  DETAILS = 'details',
  CALENDAR = 'calendar',
  VEHICLES = 'vehicles',
  AVAILABILITY = 'availability'
}

export enum PromotionsTab {
  CAMPAIGNS = 'campaigns',
  COUPONS = 'coupons',
  MEMBERSHIPS = 'memberships',
  REFERRAL = 'referral'
}

export enum CampaignDetailTab {
  DETAILS = 'details',
  CUSTOMERS = 'customers',
  ACTIVITY = 'activity'
}

export enum CouponDetailTab {
  DETAILS = 'details',
  ACTIVITY = 'activity'
}

export enum ReferralProgramDetailTab {
  DETAILS = 'details',
  REFERRERS = 'referrers',
  ACTIVITY = 'activity'
}

export enum MembershipProgramDetailTab {
  DETAILS = 'details',
  MEMBERS = 'members',
  ACTIVITY = 'activity'
}

export enum MembershipDiscountDetailTab {
  DETAILS = 'details',
  ACTIVITY = 'activity'
}

export enum GarageDetailTab {
  DETAILS = 'details',
  WORKSTATIONS = 'workstations',
  CAPACITY = 'capacity',
  SLOTS = 'slots'
}

export enum PartnerNotificationTab {
  REFUNDABLE_ORDERS = 'refundable-orders',
  SEND_MESSAGE = 'send-message',
  CREATE_INVENTORY_ORDER = 'create-inventory-order',
  PENDING_ABSENCE = 'pending-absence',
  PENDING_OVERTIME = 'pending-overtime',
  PENDING_CORRECTION_REQUEST = 'pending-correction-request'
}
